import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import AppHeader from '@/components/Header.vue'
import { getTicketDetail, confirmOrder } from '@/apis/complete-machine-delivery'
import appHost from '@/utils/app'
import { commonErrorHandle } from '@/utils/error-handle'
import { useRouter, useRoute } from 'vue-router'
import { ref, onBeforeMount, computed } from 'vue'
import { Steps, Step, Button, ImagePreview, Toast, Dialog } from 'vant'
import { statusInfoMap, detailStatusTextMap } from '@/defination/complete-machine-delivery'
import DeliveryServiceDetail2_0 from './components/delivery-service-detail-2_0.vue'
import DeliveryServiceDetailV1 from './components/delivery-service-detail-v1.vue'
import DeliveryServiceDetailX from './components/delivery-service-detail-x.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'delivery-service-detail',
  setup(__props) {

const Route = useRoute()

let is2_0Order = ref(false)
let detail = ref({
  title: '',
  titleTip: '请耐心等待工作人员联系',
  status: -1,
  titleColor: '',
  headerInfo: [],
  deliver_info: {
    img: [],
  },
  orderInfo: {
    sn: '',
    creatTime: '',
    finishTime: '',
    is_assess_auth: false,
  },
  hasAssessInfo: false,
  currentImg: [],
})

let getTicketDetailData = ref()
let deliveryServiceDetail2_0Ref = ref<InstanceType<typeof DeliveryServiceDetail2_0>>()

const isXUavOrder = computed(() => {
  return getTicketDetailData.value?.info.business_type === 5
})
async function initData(is2_0OrderRefresh = false) {
  try {
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
      loadingType: 'spinner',
      duration: 0,
    })
    let data = await getTicketDetail({
      order_no: Route.query.order_no as string,
    })
    getTicketDetailData.value = data
    is2_0Order.value = data.info.business_type === 4
    if (is2_0OrderRefresh) {
      deliveryServiceDetail2_0Ref.value?.initData()
    }

    detail.value.title = detailStatusTextMap.get(data.info.status)
    detail.value.status = data.info.status
    detail.value.titleColor = statusInfoMap.get(data.info.status).color
    detail.value.headerInfo = data.orders
    if (data.deliver_info) {
      detail.value.deliver_info.img = data.deliver_info.img.map((_) => _.url)
      detail.value.currentImg = detail.value.deliver_info.img
    }
    detail.value.orderInfo.sn = data.info.order_no
    detail.value.orderInfo.creatTime = data.info.created_at
    if (data.info.status === 50) {
      detail.value.orderInfo.finishTime = data.info.cancel_time
      detail.value.titleTip = data.info.cancel_reason
    } else {
      detail.value.orderInfo.finishTime = data.info.over_time
    }
    detail.value.orderInfo.is_assess_auth = data.info.is_assess_auth
    detail.value.hasAssessInfo = data.assess_info !== null
    Toast.clear()
  } catch (e) {
    Toast.fail(e)
    console.log(e)
  }
}

onBeforeMount(async () => {
  await initData()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "服务详情" }),
    (_unref(getTicketDetailData))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_unref(is2_0Order))
            ? (_openBlock(), _createBlock(DeliveryServiceDetail2_0, {
                key: 0,
                detail: _unref(getTicketDetailData),
                onInit: initData,
                ref_key: "deliveryServiceDetail2_0Ref",
                ref: deliveryServiceDetail2_0Ref
              }, null, 8, ["detail"]))
            : (_unref(isXUavOrder))
              ? (_openBlock(), _createBlock(DeliveryServiceDetailX, {
                  key: 1,
                  detail: _unref(getTicketDetailData),
                  onInit: initData
                }, null, 8, ["detail"]))
              : (_openBlock(), _createBlock(DeliveryServiceDetailV1, { key: 2 }))
        ], 64))
      : _createCommentVNode("", true)
  ], 64))
}
}

})